export default __webpack_public_path__ + "static/media/Encomenda-Express.5c70e2f2.png";